document.addEventListener('DOMContentLoaded', function() {
  // Use a complex selector:
  // 1. '.option-selector' : Target the fieldset
  // 2. 'input'             : Look for any input element inside
  // 3. ':checked'          : Select the one that is currently checked
  const selectedRadio = document.querySelector('.option-selector input:checked');
  const packSizeInput = document.getElementById('pack-size'); 
   
  if (selectedRadio) {
    const selectedValue = selectedRadio.value;
    console.log('Selected Radio Value:', selectedValue); // Output: medium
      packSizeInput.value = selectedValue;
    // You can also get the value of the 'name' attribute if needed
    // const inputName = selectedRadio.name;
  }
});



document.addEventListener('DOMContentLoaded', function() {
  // 1. Get all radio buttons in the group using their class
  const radioButtons = document.querySelectorAll('.opt-btn');
  const packSizeInput = document.getElementById('pack-size'); 
  // 2. Get the element where the selected value will be displayed
  const displayElement = document.getElementById('selected-value-display');

  // 3. Loop through the radio buttons to attach the event listener
  radioButtons.forEach(function(radioButton) {
    
    // Attach a 'change' event listener
    radioButton.addEventListener('change', function(event) {
      
      // 'this' refers to the radio button that was just checked
      const newValue = this.value;
      
      // Log the action for debugging
      console.log('New value selected:', newValue);
      packSizeInput.value = newValue;
      // 4. Update the content of the display element
      if (displayElement) {
        displayElement.textContent = newValue;
        
        // --- ADD YOUR CUSTOM UPDATE LOGIC HERE ---
        // For example, trigger a price update function:
        // updateProductPrice(newValue);
      }
    });
  });
});